import { render, staticRenderFns } from "./InspirationList.vue?vue&type=template&id=cf8d2bfa&"
import script from "./InspirationList.vue?vue&type=script&lang=ts&"
export * from "./InspirationList.vue?vue&type=script&lang=ts&"
import style0 from "./InspirationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports